module.exports = __webpack_public_path__ + "static/media/DesignTextEnrichesOptimized.7b8fcf67.jp2";